import { ReactNode } from "react";

/**
 * Renders a sequence of React nodes.
 * @param count The number of items to render.
 * @param callback The callback for each item.
 * @returns The items.
 */
export function renderEach(count: number, callback: (index: number) => ReactNode): ReadonlyArray<ReactNode> | null {
  const components: Array<ReactNode> = [];
  if (count < 0) return null;

  for (let i = 0; i < count; i++) {
    components.push(callback(i));
  }

  return components;
}
